var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMedium = function SvgIconMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M12.75 12c0 3.516-2.69 6.375-6 6.375s-6-2.86-6-6.375 2.69-6.375 6-6.375 6 2.86 6 6.375m9.75-6a.75.75 0 0 0-.75.75s-.375 1.247-.375 5.25.375 5.25.375 5.25a.75.75 0 1 0 1.5 0s.375-1.247.375-5.25-.375-5.25-.375-5.25A.75.75 0 0 0 22.5 6m-5.25 0c-.534 0-1.537.263-2.278 1.997-.469 1.078-.722 2.503-.722 4.003s.253 2.925.722 4.003C15.712 17.738 16.716 18 17.25 18s1.538-.262 2.278-1.997c.469-1.078.722-2.503.722-4.003s-.253-2.925-.722-4.003C18.788 6.263 17.784 6 17.25 6"
  })));
};
export default SvgIconMedium;